import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from 'auth_context';
import PublicHeader from 'pages/public/header';
import { Loading } from 'components';

const ProtectedRoute = () => {
    const { user, loading } = useAuth();
    const location = useLocation();

    const [selected, setSelected] = React.useState('');

    if (loading) return <Loading />;

    if (!user) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    const isOnboarding = location.pathname === '/onboarding';
    const isOnboarded = user.is_onboarded;

    if (!isOnboarded && !isOnboarding) {
        return <Navigate to="/onboarding" replace />;
    }

    if (isOnboarded && isOnboarding) {
        return <Navigate to="/org_portal" replace />;
    }

    return (
        <div>
            <PublicHeader selected={selected} select={setSelected} user={user} />
            <div className={`protected-content ${selected === 'dashboard' ? 'with-sidebar' : ''}`}>
                <Outlet context={{ select: setSelected, user }} />
            </div>
        </div>
    );
};

export default ProtectedRoute;
